<template lang="pug">
v-container
  v-row(
    align="center"
    justify="center"
    class="my-auto mt-5"
    )
      v-col(md="6")
        div(class="box-shape text-center")
            div(class="mb-5 pb-1")
                h2(class="pb-1") Password reset email has been sent
                p(
                style="color:#666666; font-weight: 400;") Follow these steps to reset your iMemo password.
            
            div(class="ml-5 step")
                div(class="d-flex text-left")
                    div(class="mr-4") 
                        img(
                            :src="require('../assets/icon/email.png')" 
                        )
                    div(class="flex-column")
                        div(class="font-weight-bold") Step 1:
                        div Open the email in your inbox, 
                        div check spam if you can't find it in your inbox.
                    
                div(class="d-flex text-left mt-5 pt-1")
                    div(class="mr-4") 
                        img(
                            :src="require('../assets/icon/chain.png')" 
                        )
                    div(class="flex-column")
                        div(class="font-weight-bold") Step 2:
                        div Click the link in the email

                div(class="d-flex text-left mt-5 pt-1")
                    div(class="mr-4") 
                        img(
                            :src="require('../assets/icon/lock.png')" 
                        )
                    div(class="flex-column")
                        div(class="font-weight-bold") Step 3:
                        div Continue to reset your password on the iMemo page
         
</template>

<script>
export default {
  name: "PasswordResetStepCard",
};
</script>

<style>
    .step{
        font-size: 14px;
    }

    .step img{
        width: 50px;
        height: auto;
    }
</style>